import { useState, useEffect } from "react";
import { toastFail } from "../../config";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "../../ds2/components";
import "../../index.css";
import "./OAuthLanding.css";
import { CircularProgress } from "@mui/material";
import { apiGetUser } from "../../api";
import { selectUser, setUser } from "../../redux/features/appData";
import {
  apiConfirmOAuth,
  apiVerifyGoogleAuth,
  apiVerifyMSAuth,
} from "../../services/OAuthService";
import { useConnectedAppRefresh } from "../../hooks/useConnectedAppRefresh";
import toast from "react-hot-toast";
export type AppType = "google" | "figma" | "microsoft" | "confluence";

//todo: make this dynamic for other oauth apps to use
export default function OAuthLanding() {
  const workspaceId = useSelector(selectUser)?.currentWorkspaceId;
  const dispatch = useDispatch();
  const refreshConnectedApps = useConnectedAppRefresh();
  const userId = useSelector(selectUser)?.id;

  const [statusText, setStatusText] = useState<string>("Loading...");
  const [showProgress, setShowProgress] = useState<boolean>(true);
  const codeFromApp = new URLSearchParams(window.location.search).get("code");
  const scope = new URLSearchParams(window.location.search).get("scope");
  const state = new URLSearchParams(window.location.search).get("state");
  const app = new URLSearchParams(window.location.search).get("app");

  console.log("[OAuthLandingPage] location: ", window.location);

  const navigate = useNavigate();

  const determineAppType = (): AppType => {
    if (scope?.includes("googleapis.com")) {
      return "google";
    } else if (state && state === "microsoft-winslow-oauth") {
      return "microsoft";
    } else if (app === "confluence") {
      return "confluence";
    } else {
      return "figma";
    }
  };

  const authOAuthApp = async (code: string) => {
    if (!userId) {
      return;
    }

    let result;

    console.log("[OAuthLandingPage] code: ", code);

    //figure out where the redirect is coming from for each diff app
    const appType = determineAppType();
    console.log("[OAuthLandingPage] appType: ", appType);
    if (appType === "google") {
      result = await apiVerifyGoogleAuth(userId, { code });
    } else if (appType === "microsoft") {
      result = await apiVerifyMSAuth(userId, {
        code,
        scope:
          "User.Read Files.Read.All Sites.Read.All User.Read.All Team.ReadBasic.All",
      });
    } else if (appType === "confluence") {
      console.log("[OAuthLandingPage] confluence auth", code);
      result = await apiConfirmOAuth(code, "CONFLUENCE", userId);
    }

    console.log("[OAuthLandingPage] result: ", result);

    if (result) {
      setStatusText("App is Authed!");

      await refreshConnectedApps.refresh();
      const apiUser = await apiGetUser(userId);
      dispatch(setUser(apiUser));
      navigate("/waz/settings/personal?tab=4");
    } else {
      setStatusText("App auth failed! 😢");
      setShowProgress(false);
    }
  };

  useEffect(() => {
    if (codeFromApp && workspaceId) {
      authOAuthApp(codeFromApp);
    } else {
      setStatusText("Missing information from oauth redirect");
      toast("App auth failed!", toastFail);
      navigate("/waz/settings/personal");
    }
  }, []);

  return (
    // <div id="oauth-landing-page" className={storeUser?.theme || config.theme}>
    <div id="oauth-landing-page">
      <div className="oauth-landing-page-body">
        <div className="oauth-landing-page-text">
          <h1>We're working on Authing the App for you!</h1>
        </div>
        <div className="oauth-landing-status-text">Status: {statusText}</div>

        {showProgress && <CircularProgress />}
        {!showProgress && (
          <div className="oauth-landing-status-button">
            <Button
              variant="primary"
              onClick={() => navigate("/waz/settings/personal?tab=4")}>
              Go To Settings
            </Button>
            
            {/* <button onClick={() => navigate("/waz/settings/personal?tab=4")}>
              Go To Settings
            </button> */}
          </div>
        )}
      </div>
    </div>
  );
}
